import React from 'react';
import { Container, Row, Col, Accordion } from 'react-bootstrap';
import { DEFAULT_TRIAL_PERIOD_DAYS } from '../config/config';

interface FAQItem {
  question: string;
  answer: string;
}

const trialFaqItem: FAQItem = {
  question: 'Is there really no credit card required for the free trial?',
  answer: `Yes! You can start your ${DEFAULT_TRIAL_PERIOD_DAYS}-day free trial without entering any payment information. We only ask for your credit card when you're ready to subscribe after the trial.`
};

const faqItems: FAQItem[] = [
  ...(DEFAULT_TRIAL_PERIOD_DAYS > 0 ? [trialFaqItem] : []),
  {
    question: 'Can I import my existing customer data?',
    answer: 'Absolutely! We offer free data migration assistance for all new customers. You can import your data from spreadsheets, other CRM systems, or we can help you set it up manually.'
  },
  {
    question: 'Does it work on mobile devices?',
    answer: 'Our website is mobile-friendly and works great on all devices. We\'re currently working on native mobile apps for iOS and Android to give you an even better experience on the go.'
  },
  {
    question: 'How quickly can I get started?',
    answer: 'You can be up and running in minutes! After signing up, you\'ll go through a quick setup wizard. Most businesses are fully operational within 24 hours.'
  },
  {
    question: 'Do you offer completely custom AI integrations and automations?',
    answer: 'Yes. We can design and implement custom solutions for your business, including AI-assisted lead handling, workflow automation, and third-party integrations. We start with a discovery call, then deliver a scoped implementation plan based on your goals and current tools.'
  },
  {
    question: 'What kind of support do you offer?',
    answer: 'We offer email support for all plans, priority support for Professional plans, and dedicated account managers for Enterprise customers. We also have extensive documentation and video tutorials.'
  },
  {
    question: 'Can I cancel anytime?',
    answer: 'Yes, there are no long-term contracts. You can upgrade, downgrade, or cancel your subscription at any time. If you cancel, you\'ll have access until the end of your billing period.'
  },
  {
    question: 'Is my data secure?',
    answer: 'Security is our top priority. We use bank-level encryption, daily backups, and comply with all major data protection regulations including GDPR and CCPA.'
  }
];

const FAQ: React.FC = () => {
  return (
    <section id="faq" className="faq-section-modern">
      <Container>
        <Row className="mb-5">
          <Col lg={8} className="mx-auto text-center">
            <h2 className="section-title mb-3">
              FAQ
            </h2>
            <p className="section-subtitle">
              Got questions? We've got answers.
            </p>
          </Col>
        </Row>

        <Row>
          <Col lg={8} className="mx-auto">
            <Accordion defaultActiveKey="0">
              {faqItems.map((item, index) => (
                <Accordion.Item key={index} eventKey={index.toString()}>
                  <Accordion.Header>
                    <h5 className="mb-0">{item.question}</h5>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p className="text-muted mb-0">{item.answer}</p>
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </Col>
        </Row>

        <Row className="mt-5">
          <Col className="text-center">
            <p className="text-muted">
              Still have questions? <a href="mailto:support@dhscrm.com" style={{ color: '#074a5a' }}>Contact our support team</a>
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default FAQ;
